import { SET_CAMPAIGN_NOTIFICATION_ID } from 'actions';

export function setCampaignNotificationId(campaignNotificationId: string) {
  return { campaignNotificationId, type: SET_CAMPAIGN_NOTIFICATION_ID };
}
